
  <button appTooltip="Measure" class="esk-tool" [ngClass]="{'esk-tool--active' : active===true}" (click)="toggleMeasure()"><i class="fa fa-ruler-horizontal"></i></button>
  <button appTooltip="Clear Measurements" class="esk-tool" (click)="clear()"><i class="fa fa-trash"></i></button>
  <measure-settings *ngIf=" active===true" (selectionChanged)="selectMeasureTool($event)"></measure-settings>
